import * as z from "zod";
import { FirmnessLevelEnum } from "./types";

export const BidFormSchema = z
  .object({
    contactName: z.string().min(2, "Name must be at least 2 characters"),
    companyName: z
      .string()
      .min(2, "Company name must be at least 2 characters"),
    email: z.string().email("Please enter a valid email address"),
    phoneNumber: z.string().min(10, "Please enter a valid phone number"),
    address: z.string().min(5, "Please enter a valid address"),
    city: z.string().default(""),
    nameOfLocation: z.string().default(""),
    startTime: z.date({
      required_error: "Please select a date for the event",
    }),
    eventLength: z.coerce.number().min(0).default(0),
    attendees: z.coerce.number().min(1, "Please enter the number of attendees"),
    deliveryInfo: z
      .string()
      .min(1, "Please provide delivery access information"),
    interestedGames: z
      .string()
      .min(1, "Please indicate which games interest you"),
    hasRaffle: z.enum(["YES", "NO", "UNSURE"], {
      required_error: "Please indicate if you will have a raffle.",
    }),
    wantUsToDoRaffle: z
      .enum(["YES", "NO"], {
        required_error: "Please indicate if you want us to do the raffle.",
      })
      .optional(),
    foodInfo: z.string().optional().default(""),
    firmnessLevel: z
      .nativeEnum(FirmnessLevelEnum, {
        errorMap: () => ({ message: "Invalid firmness level" }),
      })
      .default(FirmnessLevelEnum.SOFT),
    dealerSpecialInstructions: z.string().nullish().default(""),
    extraPayPerDealer: z.coerce.number().min(0).default(0),
    additionalInfo: z.string().default(""),
    additionalFee: z.coerce.number().min(0).default(0),
    discountAmount: z.coerce.number().min(0).default(0),
    splitPayment: z.boolean().default(true),
    positions: z
      .record(
        z.object({
          quantity: z.coerce.number().min(0, "Quantity must be 0 or more"),
        }),
      )
      .default({}),
    referralCode: z.string().optional().default(""),
    setupTime: z.string().optional().default(""),
    parkingInfo: z.string().optional().default(""),
  })
  .superRefine((data, ctx) => {
    if (data.hasRaffle === "YES" && !data.wantUsToDoRaffle) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: "Please indicate if you want us to do the raffle.",
        path: ["wantUsToDoRaffle"],
      });
    }
  });
